module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [(_vm.fill_info == '' && _vm.subpage == 'open') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("Felhívás, formai kritériumok")]), _vm._v(" "), _c('PerfectScrollbar', {
    staticStyle: {
      "height": "50vh",
      "border": "1px solid #f4f4f4",
      "padding": "20px 20px 0px 20px",
      "margin-bottom": "20px"
    },
    attrs: {
      "options": {
        wheelPropagation: false,
        handlers: ['click-rail', 'drag-thumb', 'keyboard', 'wheel', 'touch']
      }
    }
  }, [_c('div', {
    staticClass: "article-text medium"
  }, [_c('p', [_vm._v("A következő "), _c('strong', [_vm._v("formai kritériumok")]), _vm._v(" szerint kérjük leadni az anyagokat:")]), _vm._v(" "), _c('ul', {
    staticClass: "ordered-list with-icon",
    staticStyle: {
      "padding-bottom": "20px"
    }
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('strong', [_vm._v("Teljes terjedelem (ábrákkal, forrásjegyzékkel együtt):")]), _vm._v(" minimum 4 db, maximum 8 db A4-es méretű oldal")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('strong', [_vm._v("Betűtípus:")]), _vm._v(" 12 pt, Times New Roman betűtípus")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('strong', [_vm._v("1,5-es sorköz")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('strong', [_vm._v("Margó:")]), _vm._v(" normál, minden oldalon 2,5-ös")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v("Az "), _c('strong', [_vm._v("ábrákat, fotókat a szövegbe illesztve")]), _vm._v(" kérjük")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('strong', [_vm._v("Ábrák elnevezése")]), _vm._v(" pl.: 1. ábra: Ábra címe (forrás megjelölése – amennyiben releváns)")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('strong', [_vm._v("Az 1-es lábjegyzet az Ösztöndíjas és Témavezető adatait tartalmazza")]), _vm._v(" a következők szerint\n              "), _c('ul', [_c('li', [_c('u', [_vm._v("Ösztöndíjas neve")]), _vm._v(" nyomtatott nagybetűvel")]), _vm._v(" "), _c('li', [_c('u', [_vm._v("Szak és Kar/Tanszék és Kar/Doktori Iskola")]), _vm._v(" (ahogy releváns)")]), _vm._v(" "), _c('li', [_vm._v("Ugyanebben a lábjegyzetben kerüljön feltüntetésre a "), _c('u', [_vm._v("Témavezető neve, beosztása, szervezeti egysége")]), _vm._v("."), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                  Példa:"), _c('br'), _vm._v("\n                  DOE JÁNOS "), _c('sup', [_vm._v("1")]), _c('br'), _c('br'), _vm._v("\n                  Lábjegyzet az oldal alján:"), _c('br'), _vm._v(" "), _c('sup', [_vm._v("1")]), _vm._v(" XY szak, ZV Kar. "), _c('u', [_vm._v("VAGY")]), _vm._v(" XY Tanszék, ZV Kar "), _c('u', [_vm._v("VAGY")]), _vm._v(" Doktori Iskola neve (amelyik releváns) Témavezető: Dr. XY, egyetemi docens, Művészeti Kar, Szólóhangszerek és Művészetelmélet Tanszék\n                ")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('strong', [_vm._v("HIVATKOZÁSOK:")]), _vm._v(" MINDENKÉPP TÜNTESSETEK FEL FORRÁSJEGZYÉKET/FELHASZNÁLT IRODALMAT AZ ESSZÉ VÉGÉN. Bármely word-ben elérhető forráskezelés tökéletes (’Hivatkozások’ fül – Idézetek és Irodalomjegyzék – Stílusok), és bármilyen más, értelemszerű forrásjegyzék feltüntetési mód is rendben van.")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('strong', [_vm._v("Plagizálás teljes kizárása érdekében")]), _vm._v(" érdemes felkeresni a könyvtári kollégákat, és útmutatást kérni a Turnitin rendszer segítségével történő önellenőrzés kapcsán.")])]), _vm._v(" "), _c('p', [_vm._v("Üdvözlettel:"), _c('em', [_c('br'), _vm._v("EKÖP felelősök")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.subpage = 'data'
      }
    }
  }, [_vm._v("Tovább")])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.fill_info == '' && _vm.subpage == 'data') ? _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "nev",
      "label": "Viselt neve <span style='font-size: 10px; display: block; font-weight: 400'>(A dr-i, egyéb nevére vonatkozó előtagokat, a neve után vesszővel elválasztva tüntesse fel)</span>",
      "name": "nev",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ. ,]+",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.nev),
      callback: function($$v) {
        _vm.form.nev = $$v
      },
      expression: "form.nev"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "email",
      "label": "E-mail cím <span style='font-size: 10px; display: block; font-weight: 400'>(Pályázat beadásakor megadott)</span>",
      "name": "email",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.form.email = $$v
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "mobilszam",
      "label": "Mobilszám",
      "mask": "+99 99 / 999 9999",
      "regexp_filter": "[0-9]+",
      "name": "mobilszam",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.mobilszam),
      callback: function($$v) {
        _vm.form.mobilszam = $$v
      },
      expression: "form.mobilszam"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "disabled": "",
      "id": "neptunkod",
      "label": "Neptunkód",
      "name": "neptunkod",
      "regexp_filter": "[a-zA-Z0-9]+",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.neptunkod),
      callback: function($$v) {
        _vm.form.neptunkod = $$v
      },
      expression: "form.neptunkod"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "palyazati_azonosito",
      "label": "Pályázati azonosító <span style='font-size: 10px; display: block; font-weight: 400'>(Az egyedi azonosító számot a pályázat befogadásáról szóló értesítő e-mail-ben kapta meg)</span>",
      "name": "palyazati_azonosito",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.palyazati_azonosito),
      callback: function($$v) {
        _vm.form.palyazati_azonosito = $$v
      },
      expression: "form.palyazati_azonosito"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "errors": _vm.errors,
      "id": "tanulmanykotet_dokumentum",
      "label": "EKÖP tanulmány <span style='font-size: 10px; display: block; font-weight: 400'>(A fájl elnevezése az ösztöndíjas előtagok nélküli neve és EKÖP tanulmány legyen. Pl. Györgyné_Kékesi_Ilona_EKÖP_tanulmány)</span>",
      "name": "tanulmanykotet_dokumentum",
      "loaded_files": _vm.form.tanulmanykotet_dokumentum
    },
    on: {
      "change": function (value) {
        _vm.form.tanulmanykotet_dokumentum = value;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "10",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "dokumentumok",
      "label": "Ábrák / képek",
      "name": "dokumentumok",
      "loaded_files": _vm.form.dokumentumok
    },
    on: {
      "change": function (value) {
        _vm.form.dokumentumok = value;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_vm._l((_vm.form.dokumentum_urlek), function(url, i) {
    return _c('div', {
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "margin-bottom": "5px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.dokumentum_urlek[i]),
        expression: "form.dokumentum_urlek[i]"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Külső Url (pl.: http://webcim.hu/dokumentum.pdf)"
      },
      domProps: {
        "value": (_vm.form.dokumentum_urlek[i])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          var $$exp = _vm.form.dokumentum_urlek,
            $$idx = i;
          if (!Array.isArray($$exp)) {
            _vm.form.dokumentum_urlek[i] = $event.target.value
          } else {
            $$exp.splice($$idx, 1, $event.target.value)
          }
        }
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "button only-icon v2",
      staticStyle: {
        "margin-left": "5px"
      },
      attrs: {
        "href": _vm.form.dokumentum_urlek[i],
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    })]), _vm._v(" "), _c('button', {
      staticClass: "button only-icon",
      staticStyle: {
        "margin-left": "5px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteUrl(i)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o"
    })])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "margin-bottom": "20px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.uj_dokumentum_url),
      expression: "uj_dokumentum_url"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Külső Url (pl.: http://webcim.hu/dokumentum.pdf)"
    },
    domProps: {
      "value": (_vm.uj_dokumentum_url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.uj_dokumentum_url = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button only-icon v2",
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addDocumentUrl
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.saving,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.save(1)
      }
    }
  }, [_vm._v("Mentés")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.saving,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.save(2)
      }
    }
  }, [_vm._v("Véglegesít")])])])]) : _vm._e(), _vm._v(" "), (_vm.fill_info != '') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("EKÖP Tanulmánykötet")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.fill_info)
    }
  })])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "button with-icon",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "href": "assets/pdf/ekop_tanulmanykotet_formai_kovetelmenyek.pdf",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v("Formai követelmények letöltése")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("EKÖP Tanulmánykötet")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "info-box download"
  }, [_vm._v("\n          Az EKÖP Tanulmánykötetben szereplő írások formai követelményeit tartalmazó dokumentum "), _c('span', {
    staticClass: "highlight"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "assets/pdf/ekop_tanulmanykotet_formai_kovetelmenyek.pdf",
      "title": "Formai követelmények"
    }
  }, [_vm._v("ITT")])]), _vm._v(" tölthető le.\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-de41e174"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/competition/ekop_tanulmanykotet.vue
// module id = 406
// module chunks = 0